import { Box, Typography } from "@mui/joy";

import { LandingSection, LandingContainer } from "../../../LandingLayout";
import { StepCard } from "./components/StepCard/StepCard";
import { FadeIn } from "~/common/components";

export interface Step {
  number: string;
  title: string;
  description: string;
  imageDark: string;
  imageLight: string;
}

const steps: Step[] = [
  {
    number: "01",
    title: "Підключіть Telegram канал",
    description:
      "Підключіть бота до группи с співробітниками, або в переписці з ботом за дві хвилини.",
    imageDark: "/hiw_step_1_dark.png",
    imageLight: "/hiw_step_1_light.png",
  },
  {
    number: "02",
    title: "Завантажте торгівельні марки",
    description:
      "Додайте заявки просто вказавши їх номери з СІС. Можна списком.",
    imageDark: "/hiw_step_2_dark.png",
    imageLight: "/hiw_step_2_light.png",
  },
  {
    number: "03",
    title: "Отримуйте сповіщення",
    description: "Brandly нагадуватиме за дедлайни та нові запити кожен день.",
    imageDark: "/hiw_step_3_dark.png",
    imageLight: "/hiw_step_3_light.png",
  },
];

export const HowItWorks = () => {
  return (
    <LandingSection variant="hero" id="how-it-works">
      <LandingContainer size="md" sx={{ textAlign: "center", mb: 6 }}>
        <FadeIn offsetY={20} duration={300} delay={100}>
          <Typography
            sx={{
              fontSize: { xs: "0.75rem", md: "0.875rem" },
              fontWeight: 600,
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              color: "primary.500",
              mb: 1.5,
            }}
          >
            Як це працює
          </Typography>
        </FadeIn>
        <FadeIn offsetY={20} duration={300} delay={200}>
          <Typography
            level="h2"
            sx={{
              fontSize: { xs: "1.5rem", md: "2rem", lg: "2.5rem" },
              fontWeight: 700,
              lineHeight: 1.2,
            }}
          >
            Почніть за 3 простих кроки
          </Typography>
        </FadeIn>
      </LandingContainer>

      <Box
        sx={{ display: "flex", flexDirection: "column", gap: { xs: 2, md: 4 } }}
      >
        {steps.map((step, index) => (
          <StepCard key={step.number} step={step} index={index} />
        ))}
      </Box>
    </LandingSection>
  );
};
